<template>
	<div>
		<header>
			<h1>Edit Group</h1>
		</header>
		<div>
			<loader v-if="!activeItem"></loader>
			<group-form v-if="activeItem" :group="activeItem" cta="Update Group" method="patch"/>
		</div>
	</div>
</template>
<script>
import {createNamespacedHelpers} from "vuex";

const {mapActions, mapGetters} = createNamespacedHelpers("groups");

export default {
	computed: mapGetters([
		"activeItem",
	]),

	methods: mapActions([
		"activateModel",
	]),

	created() {
		this.activateModel(this.$route.params.group);
	},
};
</script>
